import { Card, pn, Stack, ValidationErrors } from "@compass/core";
import {
  CustomFilterEntity,
  StudentFilter as StudentFilterModel,
  StudentReportServiceSummaryRequest,
  StudentReportServiceSummaryResource,
} from "generated/openApi";
import produce from "immer";
import { useEffect, useState } from "react";
import ApiService from "services/apiService";
import { ServiceSummaryDisplay } from "./ServiceSummaryDisplay";
import { StudentServiceFilter } from "pages/students/student-services/StudentServiceFilter";

export const ServiceSummaryRequest = (props: {
  initialized: boolean;
  request: StudentReportServiceSummaryRequest;
  setRequest: (value: StudentReportServiceSummaryRequest) => void;
  validationErrors: ValidationErrors;
}) => {
  const [resource, setResource] = useState<StudentReportServiceSummaryResource>({});

  useEffect(() => {
    if (props.initialized) {
      ApiService.studentReports.getServiceSummaryRequest().then((response) => {
        props.setRequest(response);
      });

      ApiService.studentReports.getServiceSummaryResource().then((response) => {
        setResource(response);
      });
    }
  }, [props.initialized]);

  return (
    <Stack spacing="lg">
      <Card header="Filter By">
        <StudentServiceFilter
          hiddenEntities={[CustomFilterEntity.StudentEnrollment]}
          studentServicefilter={props.request.studentServiceFilter || {}}
          studentDemographicsFilter={props.request.studentFilter || {}}
          customFilters={props.request.customFilters || []}
          setCustomFilters={(filter) =>
            props.setRequest(
              produce(props.request, (draft) => {
                draft.customFilters = filter;
              })
            )
          }
          setStudentServiceFilter={(filter) =>
            props.setRequest(
              produce(props.request, (draft) => {
                draft.studentServiceFilter = filter;
              })
            )
          }
          setStudentDemographicFilter={(filter) =>
            props.setRequest(
              produce(props.request, (draft) => {
                draft.studentFilter = filter;
              })
            )
          }
        />
      </Card>

      <ServiceSummaryDisplay
        display={props.request.display || {}}
        setDisplay={(display) =>
          props.setRequest(
            produce(props.request, (draft) => {
              draft.display = display;
              const previouslySelected = props.request.display?.groupByProperties?.includes("StudentCurrentSchool");
              const selected = display.groupByProperties?.includes("StudentCurrentSchool");
              if (selected && !previouslySelected) {
                draft.display = {
                  ...display,
                  aggregateProperties: Array.from(new Set([
                    ...(display.aggregateProperties || []),
                    "TotalStudents",
                    "CohortEnrollmentTotal",
                    "ServiceParticipationPercentage",
                  ])),
                };
              } else if (!selected) {
                draft.display = {
                  ...display,
                  aggregateProperties: display.aggregateProperties?.filter((property) =>
                    property !== "CohortEnrollmentTotal" && property !== "ServiceParticipationPercentage"
                  ),
                };
              }
            })
          )
        }
        resource={resource.display || {}}
        validationErrors={props.validationErrors[pn<StudentReportServiceSummaryRequest>("display")] || {}}
      />
    </Stack>
  );
};
